import api from "../../../services/api";

const getAll = ({ commit }, { params = {} }) => {
  return new Promise((resolve, reject) => {
    api.get(`/master/strata`, { params }).then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_USERS", res.data);
          return res.data;
        }
      },
      error => {
        reject(error);
      }
    );
  });
};

const getDetail = ({ commit }, id) => {
  return new Promise((resolve, reject) => {
    api.get(`/master/strata/${id}`).then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_USERS", res.data);
          return res.data;
        }
      },
      error => {
        reject(error);
      }
    );
  });
};

const putOrPush = ({ commit }, { id, payload }) => {
  commit("SET_USERS", "");
  return new Promise((resolve, reject) => {
    api.put(`/master/strata/${id}`, payload).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};

const remove = ({ state }, id) => {
  console.log(state.id)
  return new Promise((resolve, reject) => {
    api.delete("/master/strata/" + id).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};
const getJobLevel = ({ commit }) => {
  return new Promise((resolve, reject) => {
    api.get(`/master/level-jabatan`).then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_USERS", res.data);
          return res.data;
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
export default {
  getAll,
  putOrPush,
  getDetail,
  getJobLevel,
  remove
};
